const TRANSCLUSION_FROM_NEW_PASSWORD = 'TRANSCLUSION_FROM_NEW_PASSWORD';
const TRANSCLUSION_SHOW = 'TRANSCLUSION_SHOW';
const TRANSCLUSION_HIDE = 'TRANSCLUSION_HIDE';

const transclusionShow = (typeName) => ({
  type: TRANSCLUSION_SHOW,
  payload: {
    typeName
  }
});

const transclusionFromNewPassword = (errors) => ({
  type: TRANSCLUSION_FROM_NEW_PASSWORD,
  payload: {
    errors
  }
});

const transclusionHide = () => ({
  type: TRANSCLUSION_HIDE
});

export {
  TRANSCLUSION_FROM_NEW_PASSWORD,
  TRANSCLUSION_SHOW,
  TRANSCLUSION_HIDE,
  transclusionFromNewPassword,
  transclusionShow,
  transclusionHide
};
